module.exports = __webpack_public_path__ + "static/media/img003.970ea338.jpg";